import {useEffect, useState} from 'react';
import { jsxActions as cocViewActions} from '../../../actions/CoC/cocViewActions.js';
import { jsxActions as cocTestsViewGridActions} from '../../../actions/CoC/cocTestsViewGridActions.js';
import useRedux from 'infrastructure/js/hooks/useRedux';
import Overlay from 'infrastructure/js/components/Overlay/overlay';
import CoCView from './cocView';
import useNavBarUpdate from 'infrastructure/js/hooks/useNavBarUpdate';
import {navigationStates} from '../../../enums/navigationStates';

const getState = (state) => {
  return {
    loading: state.coc.getIn(['cocView', 'loading'])
  }
}

const allActions = {
  cocViewActions,
  cocTestsViewGridActions,
};


function CocViewWrapper (props) {
  const { state, actions } = useRedux(allActions, getState);
  const { /*formData,*/ loading } = state;

  const [initialized, setInitialized] = useState(false);
  const [item, setItem] = useState(null);
  const updateNavBar = useNavBarUpdate();

  useEffect(() => {
    let cocId = props.match.params.cocId;
    if (cocId) {
      actions.cocViewActions.setCoCId(+cocId);
      actions.cocViewActions.init(+cocId).then(data => {
        if (data) {
          setItem(data);
        }
        setInitialized(true);
      })
    }
    else {
      setInitialized(true);
    }

    return () => {
      setInitialized(false);
      actions.cocViewActions.unmount();
    }
  }, [props.match.params.cocId]);

  useEffect(() => {
    updateNavBar(navigationStates.COC, 'CoC ' + (item?.name ?? ''), item?.qplVersion ?? '');
  }, [updateNavBar, item]);

  return  initialized ?
    <CoCView initialData={item}
             actions={actions}
             {...props } /> :
    <Overlay.Loading />
}

export default CocViewWrapper;
